module.exports = __webpack_public_path__ + "22328adaa60d109c8646ad1147eea1f6.png";